import TextField from "@mui/material/TextField";
import styles from "./RtsScanModule.styles";
import Button from "@mui/material/Button/Button";
import RtsScanStore from "./RtsScanStore";
import { useState } from "react";
import { toast } from "react-toastify";
import CameraComponent from "./CameraComponent";

interface ManualEntryComponentProps {
  onClose: any;
  onSubmit: any;
}

const ManualEntryComponent: React.FC<ManualEntryComponentProps> = ({
  onClose,
  onSubmit,
}) => {
  const {
    scannedData,
    setLatestScanBarcode,
    latestImage,
    latestScanBarcode,
    setLatestImage,
  } = RtsScanStore();

  const [openCamera, setOpenCamera] = useState<boolean>(false);

  function handleCameraClose() {
    setOpenCamera(false);
    setLatestImage("");
  }

  function handleCameraSubmit() {
    setOpenCamera(false);
  }
  return (
    <>
      {!openCamera && (
        <>
          <TextField
            style={styles.manualEntryTextField}
            variant="outlined"
            placeholder="Enter barcode manually"
            onChange={(e) => setLatestScanBarcode(e.target.value)}
          />
          <p>If the barcode is not readable, please upload the image.</p>
          <div style={styles.camButton}>
            <Button variant="outlined" onClick={() => setOpenCamera(true)}>
              Open Camera
            </Button>
          </div>

          <div style={styles.imagePreviewContainer}>
            <img
              style={
                latestImage !== "" ? styles.imagePreview : { display: "none" }
              }
              src={latestImage}
              alt="Preview Image"
            />
          </div>

          <div style={styles.manualEntryModuleButtons}>
            <Button
              style={styles.buttonItem}
              variant="outlined"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              style={styles.buttonItem}
              variant="contained"
              onClick={() => {
                if (latestImage === "" && latestScanBarcode.trim() === "") {
                  toast.error("Blank barcode can't be added.");
                  return;
                }
                if (
                  latestImage === "" &&
                  (latestScanBarcode.trim().length < 3 ||
                    latestScanBarcode.trim().length > 30)
                ) {
                  toast.error(
                    "Barcode's length can't be less than 3 , and can't be greater than 30. "
                  );
                  return;
                }
                onSubmit();
              }}
            >
              Submit
            </Button>
          </div>
        </>
      )}

      {openCamera && (
        <CameraComponent
          onSubmit={handleCameraSubmit}
          onClose={handleCameraClose}
        />
      )}
    </>
  );
};

export default ManualEntryComponent;
